import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_PIP_ACTIVE } from './actionTypes';
/**
 * The default state for the pip feature.
 */
const DEFAULT_STATE = {
    isPiPActive: false
};
/**
 * Reduces the Redux actions of the pip feature.
 */
ReducerRegistry.register('features/pip', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_PIP_ACTIVE:
            return {
                ...state,
                isPiPActive: action.isPiPActive
            };
        default:
            return state;
    }
});
